// packages/world-model/src/traits/supporter/index.ts

export { SupporterTrait } from './supporterTrait.js';
export { SupporterBehavior, type IAddItemToSupporterResult, type IRemoveItemFromSupporterResult } from './supporterBehavior.js';
